<template>
  <div class="data_brain_wrap">
    <div class="brain_title">选择我们的四个理由</div>
    <div class="brain_desc">Top Advantages Of Studying Abroad</div>

    <el-row class="card_wrap" type="flex" >
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        style="width: 300px"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div :class="item.icon"  class="item_icon"></div>
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_bg" ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: "el-icon-star-on",
          title: '精锐顾问团队',
          desc: '文汇昌教育的核心顾问团队，100%由专业升学规划师和国际教育专家组成，确保精准升学策略与高效辅导。',
        },
        {
          icon: "el-icon-apple",
          title: '深厚资源优势',
          desc: '专注整合优质教育资源，致力于发展职业教育。涵盖中考、高职高考、高考、专升本、考研、国际教育、高端就业等多个领域。经过10年发展，旗下包含多个子公司。',
        },
        {
          icon: "el-icon-s-custom",
          title: '个性化全程支持',
          desc: '一对一专属顾问，提供从升学规划、学术晋升至职业路径的全程个性化指导，实现 “一人一案” 的深度定制。对学生的求学生活进行协助，让家长没有后顾之忧。',
        },
        {
          icon: "el-icon-s-cooperation",
          title: '优质子女国际教育',
          desc: '享受免费公立教育和医疗，考取国内外名校机会更大，为下一代创造更美好的未来。',
        },
      ],
    }
  },
  methods:{
    handleNavigate(){
      this.$router.push('/production/1').catch((v) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #ff914E;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      &:hover .item_icon {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 20px;
        font-weight: bold;
        color: #203040;
        text-align: center;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 14px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_icon {
        z-index: 2;
        position: inherit;
        font-size: 64px;
        color: #ff914E;
      }

      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>